var React = require('react');

function TickIconAltInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.8714 2.71433L12.4225 1.13976C12.251 0.953412 11.9729 0.953412 11.8014 1.13976L5.76567 7.69883L3.19851 4.90921C3.02709 4.72286 2.749 4.72286 2.57754 4.90921L1.12861 6.48378C0.957129 6.67009 0.957129 6.97226 1.12861 7.15861L5.4552 11.8602C5.54094 11.9534 5.65333 12 5.7657 12C5.87809 12 5.99049 11.9534 6.0762 11.8602L13.8714 3.38913C13.9538 3.29966 14 3.17827 14 3.05175C14 2.92516 13.9538 2.80384 13.8714 2.71433Z","fill":"current","stroke":"current","strokeWidth":"1.5"}));
}

TickIconAltInline.defaultProps = {"width":"15","height":"13","viewBox":"0 0 15 13","fill":"none"};

module.exports = TickIconAltInline;

TickIconAltInline.default = TickIconAltInline;
